import { saveAs } from 'file-saver';
import _ from 'lodash';
import React from 'react';
import { Button } from 'antd';
import { Icon } from 'xadmin-ui';
import XLSX from 'xlsx';
import { api, use } from 'xadmin'

/* see Browser download file example in docs */
function s2ab(s/*:string*/)/*:ArrayBuffer*/ {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}

const getColName = number => {
  if (number < 0) return
  const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let name = ''
  const isAliquot = number / 26
  const s = number % 26
  const getStr = k => str.split('')[parseInt(k) - 1]
  if (isAliquot > 1) {
    name += getStr(s == 0 ? isAliquot - 1 : isAliquot)
  }
  if (s == 0) { name += 'Z' }

  if (s > 0) { name += getStr(s) }
  return name
}
const getMergeCol = (arr, origin = 1) => {
  const merges = []
  Array.from(new Set(arr.filter(Boolean))).map(k => {
    if (k != '') {
      const si = _.findIndex(arr, n => n == k)
      const ei = _.findLastIndex(arr, n => n == k)
      merges.push({ s: `${getColName(si + 1)}${origin}`, e: `${getColName(ei + 1)}${origin}` })
    }
  })
  return merges
}
const getFieldProp = (model, field) => {
  return field.split('.').reduce((obj, f) => {
    return obj && obj.properties && obj.properties[f]
  }, model)
}
const getText = node => {
  if (node.textContent) {
    return node.textContent
  }
  if (node.childNodes && node.childNodes.length > 0) {
    if (node.className.indexOf('anticon') >= 0) {
      return node.title
    }
    return getText(node.childNodes[0])
  }
}

const getTableData = list => {
  const rows = []
  for (let i = 0; i < list.length; i++) {
    const row = []
    for (let j = 0; j < list[i].childNodes.length; j++) {
      const node = list[i].childNodes[j]
      if ((node.className).indexOf('ant-table-selection-column') < 0 && (node.className).indexOf('ant-table-cell-fix-left-last') < 0) {
        const text = getText(node)
        row.push(text)
      }
    }
    rows.push(row)
  }

  return rows
}

const ExportBtn = props => {
  const { model, ids, fields, getModelState } = use('model', state => ({
    ids: state.ids,
    fields: state.filter.fields
  }))
  const { loading } = use('redux', state => state.loading[`${model.key}.items`])
  const [dataLoading, setDataLoading] = React.useState(false)

  const items = React.useMemo(() => {
    const { items } = getModelState()
    return ids.map(id => items[id]).filter(item => !_.isNil(item))
  }, [ids])


  const getData = () => {
    const tags = []
    if (fields) {
      fields.filter(key => key.indexOf('param-') == 0).forEach(key => {
        const tagId = key.substring(6)
        items.forEach(item => {
          tags.push({ id: item.id, tagId })
        })
      })
    }
    if (tags && tags.length > 0) {
      setDataLoading(true)
      return api({ name: 'core/data' })
        .fetch('/latest', { method: 'POST', body: JSON.stringify(tags) })
        .then(({ json }) => {
          const payload = {}
          json.forEach(({ tagId, time, id, value }) => {
            payload[`${id}|param-${tagId}`] = { value, time: time * 1000 }
          })
          setDataLoading(false)
          return payload
        })
    }
  }

  const onExport = async () => {
    /* convert state to workbook */
    const title = model.title || model.name
    const domId = model && model.model && model.model.id

    // 参数汇总页面获取表格内容
    let tbody = document.querySelector(`#paramTable-${domId} .ant-table-tbody`)
    let thead = document.querySelector(`#paramTable-${domId} .ant-table-thead`)
    // 资产页面获取表格内容
    let urlModelId
    if (!tbody || !thead) {
      let query = location.search
      if (query.indexOf('?') >= 0) {
        query = query.substring(1)
      }
      query.split('&').map(item => {
        if (item.indexOf('model') >= 0) {
          const arr = item.split('=')
          urlModelId = arr && arr[1] ? arr[1] : null
        }
      })
      //关注资产
      if (query == 'focus=true') urlModelId = 'true'

      tbody = document.querySelector(`.xadmin-model-list-nodes-${urlModelId}-Extends .ant-table-tbody`)
      thead = document.querySelector(`.xadmin-model-list-nodes-${urlModelId}-Extends .ant-table-thead`)
    }

    if (!tbody || !thead) {
      // 导出普通表格
      tbody = document.querySelector(`${props.export_className || null} .ant-table .ant-table-tbody`)
      thead = document.querySelector(`${props.export_className || null} .ant-table .ant-table-thead`)
    }

    if (!tbody || !thead) return

    const rows = getTableData(tbody && tbody.childNodes)
    const headers = getTableData(thead && thead.childNodes)

    let level2header = {}
    fields.map(field => {
      const property = getFieldProp(model, field) || {}
      if (property.level2) {
        level2header[property.level2] = [
          ...(level2header[property.level2] || []),
          (property.title || _.startCase(field)) + property.level2
        ]
      }
    })

    const header = headers && headers[0]
    // 处理二级表头
    if (header) {
      header.map((item, i) => {
        if (level2header[item]) {
          header.splice(i, 1, ...level2header[item])
        }
      })
    }
    const ws = XLSX.utils.aoa_to_sheet([headers && headers[0], ...rows])

    // 根据配置的宽度生成表格宽度
    // ws['!cols'] = report.columns.filter(Boolean).map(col => ({ wpx: col.width ? col.width : 100 }))
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, title)

    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' })
    /* send to client */
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `导出-${title}.xlsx`)
  }

  const active = !!(!loading && items)
  return (
    <Button onClick={onExport} disabled={!active} style={{ marginRight: 2.5 }}>
      <Icon type={dataLoading ? 'loading' : 'download'} /> 导出
    </Button>
  )
}

export default {
  blocks: {
    'model.list.submenu.btngroup': ({ model }) => model.export_files && <ExportBtn
      bsSize="sm"
      types={model.export_files}
      export_className={model.export_className}
    />
  }
}

export { ExportBtn };

